import { Component, OnInit } from '@angular/core';
import { WebServiceService } from './../web-service.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-exam-result-list',
  templateUrl: './exam-result-list.component.html',
  styleUrls: ['./exam-result-list.component.scss']
})
export class ExamResultListComponent implements OnInit {

  public resultData: any;
  constructor(
    public webService: WebServiceService,
    private router: Router,
  ) { 
  }

  ngOnInit(): void {
    this.webService.getPublishedResults().subscribe((data: any) => {
      this.resultData = data;
    });
  }

  openResult(result: any) {
      this.router.navigate(['result', result.resultCol])
  }

}
